<template>
	<div :class="`button ${mainButton}`" v-if="mainButton" @click="$emit('goto', 5)">
		<div class="button__content" @click="sendEvent('Uchastvujte_v_konkurse','m_Uchastvujte_v_konkurse')">
			<div class="button__icon">
				<img src="../assets/img/gift.svg" alt="">
			</div>
			<div class="button__text">
				<div class="button__title">Итоги конкурсов</div>
				<div class="button__link">
					<a href="javascript:void(0)">Подробнее</a>
				</div>
			</div>
		</div>
	</div>
	<div class="button" v-else @click="$router.push('/#5')">
		<div class="button__content" @click="sendEvent('Uchastvujte_v_konkurse','m_Uchastvujte_v_konkurse')">
			<div class="button__icon">
				<img src="../assets/img/gift.svg" alt="">
			</div>
			<div class="button__text">
				<div class="button__title">Итоги конкурсов</div>
				<div class="button__link">
					<a href="javascript:void(0)">Подробнее</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'QuizButton',
		props: {
			mainButton: String,
		},
		methods: {
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		}
	}
</script>

<style lang="sass">
	.button
		position: fixed
		z-index: 100
		bottom: 0
		left: vw(-75px)
		margin-bottom: vw(33px)
		background-color: $white
		box-shadow: 20px 20px 20px rgba(34, 81, 121, 0.2)
		border-radius: vw(40px)
		border: vw(4px) solid rgba(0, 46, 86, 0.2)
		cursor: pointer
		@media screen and (max-width: 1000px)
			position: absolute
			margin-bottom: 0
			width: vwm(314px)
			height: vwm(66px)
			border-radius: vwm(35px)
			border-top-left-radius: 0px
			border-bottom-left-radius: 0px
			border: vwm(2px) solid rgba(0, 46, 86, 0.2)
		&--main
			position: absolute
			bottom: vw(8px)
			@media screen and (max-width: 1000px)
				bottom: vwm(12px)
		&__content
			display: flex
			font-family: 'Montserrat'
			padding-left: vw(84px)
			padding-top: vw(13px)
			padding-bottom: vw(13px)
			padding-right: vw(39px)
		&__icon
			width: vw(46px)
			margin-right: 33px
			@media screen and (max-width: 1000px)
				width: vwm(46px)
				margin-right: vwm(7px)
				margin-left: vwm(16px)
				margin-top: vwm(5px)
			img
				width: 100%
		&__text
			margin-top: vw(3px)
		&__title
			font-size: vw(18px)
			color: $blue
			font-weight: 600
			margin-bottom: vw(7px)
			@media screen and (max-width: 1000px)
				font-size: vwm(16px)
				padding-top: vwm(12px)
				margin-bottom: vwm(-1px)
		&__link
			a
				font-size: vw(12px)
				color: rgba(0, 46, 86, 0.7)
				text-decoration: none
				border-bottom: 1px dashed rgba(0, 46, 86, 0.4)
				@media screen and (max-width: 1000px)
					font-size: vwm(10px)
					margin-top: vwm(4px)
					display: inline-block
					line-height: 1.3
</style>